import React from 'react';
import { Button, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const RefreshButton = ({
  onClick,
  loading = false,
  label = 'Refresh',
  showLabel = true,
  tooltip = 'Reload data',
  size = 'small',
  type = 'default',
}) => {
  return (
    <Tooltip title={tooltip}>
      <Button
        type={type}
        icon={<ReloadOutlined spin={loading} />}
        onClick={onClick}
        loading={loading}
        size={size}
      >
        {showLabel && label}
      </Button>
    </Tooltip>
  );
};

export default RefreshButton;
